import React, { FC } from 'react';
import useLiveRamp from 'shared/hooks/optimizely/useLiveRamp';
import { withOptimizely, WithOptimizelyProps } from 'shared/optimizely';

import footerSnippet from './assets/footer.html.txt';
import liverampFooterSnippet from './assets/liveramp-footer.html.txt';

const Footer: FC<WithOptimizelyProps> = ({ optimizely }) => {
    const _useLiveRamp = useLiveRamp(optimizely);

    return (
        <div
            data-testid="universal-footer"
            dangerouslySetInnerHTML={{
                __html: _useLiveRamp ? liverampFooterSnippet : footerSnippet
            }}
        />
    );
};

export default withOptimizely(Footer);
